import {Component, HostBinding, input} from '@angular/core';

@Component({
  selector: 'app-try-reason',
  standalone: true,
  imports: [],
  templateUrl: './try-reason.component.html',
})
export class TryReasonComponent {
  @HostBinding('class') class = 'flex flex-row items-center gap-2';
  text = input.required<string>();
}
